import Item from "./Item"

const ItemList = ({ instruments }) => {

    return (
       <Item  instrumentItems={instruments}/>
    )

}

export default ItemList